<ng-template [ngIf]="showFlyBackSection">
  <app-flyback-flight-results [copyLoaded]='copyLoaded' [appCopy]='appCopy' [appAirportCopy]='appAirportCopy'
    [selectedLanguage]='selectedLanguage' [languageCode]='languageCode' [firstLoad]="firstLoad"
    [flightResultsLoading]="flightResultsLoading" [flightData]="flightData" [flightResults]="flightResults"
    (selectFlight)="selectFlight($event)" (searchNonDirect)="searchNonDirect($event)"
    (handlePageClick)='handlePageClick($event)' (handlePageNumberClick)='handlePageNumberClick($event)'
    [pagingArr]='pagingArr' [pageSetSize]='pageSetSize' [selectedPage]='selectedPage' [activeSetIndex]='activeSetIndex'
    (cancelFlightRequest)="cancelFlightRequest($event)" (flightSelectionInprogress)="flightSelectionInprogress"
    (flightNumberFilter)="flightNumberFilter($event)" [bookingReference]='bookingReference'
    (flightConnectionCount)='flightConnectionCount'>
  </app-flyback-flight-results>

  <app-modal-product-type *ngIf="modalSelectingProductType" [com]="'flyBack'"
    (confirmFlightProductType)="getSelectedProductType($event)" [isSessionScreen]="autoSetCCDforFlyback"
    [searchByFlightNumber]="false" [modalData]="modalData"></app-modal-product-type>

</ng-template>
